import {Component, ElementRef, HostListener, Inject, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AppointmentDialogDataModel} from '../../models/appointment-dialog-data.model';
import {PatientCaseViewDataModel} from '../../../../models/patient/patient-case-view-data.model';
import {CalendarCaseProcedureModel} from '../../../../models/appointments/calendar-case-procedure.model';
import {SchedulingService} from '../../scheduling.service';
import {LandingPageService} from '../../../../services/landing-page.service';
import {CaseProcedureConfigurationModel} from '../../../../models/caseProcedures/case-procedure-configuration.model';
import {MatTab, MatTabChangeEvent, MatTabGroup} from '@angular/material/tabs';
import {TdoListComponent} from '../../../../tdo-controls/common/tdo-list/tdo-list.component';

@Component({
  standalone: false,
    selector: 'app-appointment-procedure-dialog',
    templateUrl: './appointment-procedure-dialog.component.html',
    styleUrls: ['./appointment-procedure-dialog.component.scss']
})
export class AppointmentProcedureDialogComponent implements OnInit {
    @ViewChild('appointmentsDiv') appointmentsDiv: ElementRef;
    @ViewChild('tdoList') tdoList: TdoListComponent;

    @ViewChild('tabGroup') tabGroup: MatTabGroup;
    @ViewChild('me') apptTab: MatTab;
    selectedPatientCaseProcedures: CalendarCaseProcedureModel[] = [];
    type: string = 'appointment';
    searchStr = '';
    filteredProcedures: CaseProcedureConfigurationModel[] = [];
    casesLoading: boolean = false;

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (String.fromCharCode(event.keyCode).match(/(\w|\s)/g)) {
            // this.searchStr += event.key;
            // this.filteredProcedures = this.data.procedures.filter(p => p.ProcedureName.includes(this.searchStr));
            /* setTimeout(() => {
        this.searchStr = '';
      }, 1000);*/
        } else {
            switch (event.key) {
            case 'ArrowUp':
                this.appointmentsDiv.nativeElement.scrollTop -= 10;
                break;
            case 'ArrowDown':
                this.appointmentsDiv.nativeElement.scrollTop += 10;
                break;
            default:

            }
        }
    }

    constructor(@Inject(MAT_DIALOG_DATA) public data: AppointmentDialogDataModel,
                private dialogRef: MatDialogRef<AppointmentProcedureDialogComponent>,
                private landingPageService: LandingPageService,
                private schedulingService: SchedulingService) {
        this.filteredProcedures = data.procedures;
    }

    ngOnInit(): void {
        this.getPatientCases();
    }

    private getPatientCases(isExisting = false) {
        this.casesLoading = true;
        this.landingPageService.getPatientsCases4Landing(this.data.appointment.PatientId).subscribe((res) => {
            this.data.patientCases = res;
            this.casesLoading = false;
            if (this.data.patientCases.length > 0)
            {this.onSelectedCase(this.data.patientCases[0]); }
        });
    }

    onProcedureSelected(proc: any) {
        this.data.appointment.CaseProcedureId = proc.CaseProcedureId;
        this.dialogRef.close(true);
    }

    onSelectedCase(cse: PatientCaseViewDataModel) {
        this.data.appointment.PatientCaseId = cse.PatientCaseId;
        this.schedulingService.getCaseProcedures(cse.PatientCaseId).subscribe((res) => {
            this.selectedPatientCaseProcedures = res;

            // if (res && res.length > 0) {
            //     this.data.procedures = this.data.procedures.concat(res.map((r) => r.procedure));
            // } else {
            //     /* this.procedureDropDown.value = 'No procedure for selected case';
            //     this.procedureDropDown.instance.close();*/
            // }
        });
    }

    onCaseProcedureSelected(proc: CalendarCaseProcedureModel) {
        const selectedProcedure = proc;

        this.data.appointment.CaseProcedureId = selectedProcedure.procedure.CaseProcedureId;
        this.data.appointment.PatientCaseId = selectedProcedure.patientCaseId;
        this.data.appointment.CaseWorkItemId = selectedProcedure.caseWorkItemId;
        this.data.appointment.Procedure = selectedProcedure.procedure;
        this.dialogRef.close(this.data);
    }

    onProcedureSelectionChange(event: any) {
        const selectedProcedure = event;

        this.data.appointment.CaseProcedureId = selectedProcedure.CaseProcedureId;
        this.data.appointment.PatientCaseId = selectedProcedure.patientCaseId;
        this.data.appointment.CaseWorkItemId = selectedProcedure.caseWorkItemId;
        this.data.appointment.Procedure = selectedProcedure;
        this.dialogRef.close(this.data);
    }

    isProcedureSelected(cse: PatientCaseViewDataModel) {
        return cse?.PatientCaseId?.toLowerCase() === this.data.appointment?.PatientCaseId?.toLowerCase();
    }

    onCancelClick() {
        this.dialogRef.close(null);
    }

    onOkClick() {

    }

    onArrowDown(divy: HTMLDivElement) {
        console.log('Arrow Down');
        divy.scrollTo(0, 500);
    }

    clearSearch() {
        this.searchStr = '';
        this.filteredProcedures = this.data.procedures.filter(p => p.ProcedureName.includes(this.searchStr));
    }

    onSearchInputFinished($event: string) {
        this.searchStr = $event;
        this.filteredProcedures = this.data.procedures.filter(p => p.ProcedureName.includes(this.searchStr));
    }

    onTabChange(event: MatTabChangeEvent) {
        // this.type = event.tab.textLabel.toLowerCase();
      this.type = event.index === 0 ? 'appointment' : 'case';
    }

    onAppointmentsFocusIn(event: FocusEvent) {
        console.log('Appointment tab focused in');
        const tmp = setInterval(() => {
            if (this.tdoList) {
                clearInterval(tmp);
                this.tdoList.focus();
            }
        }, 200);

    }

    onTabGroupFocusChange($event: MatTabChangeEvent) {
        console.log('tab group focus change');
    }

    onTabGroupFocusIn($event: FocusEvent) {
        const tmp = setInterval(() => {
            if (this.tdoList) {
                clearInterval(tmp);
                this.tdoList.focus();
            }
        }, 200);
    }
}
